function getTitle(vm) {
	const { title } = vm.$options;

	if (title) return "function" === typeof title ? title.call(vm) : title;
}

export default {
	methods: {
		setPageTitle(title) {
			this.$nextTick(() => {
				document.title = `LimeIQ - ${title}`;
			});
		},
	},
	mounted() {
		const title = getTitle(this);

		if (title) document.title = `LimeIQ - ${title}`;
	},
};
